<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
    style="height: 86vh;"
  >
    <v-row justify="center">
      <v-col
        cols="6"
        md="5"
      >
      <base-material-card
          icon="mdi-clipboard-text"
          title=""
          class="px-5 py-3"
        >
        <template>
          <v-sheet class="mx-auto" width="300">
            <v-form ref="form" fast-fail @submit.prevent="submit">  
              <v-text-field
                v-model="id"
                label="ID"
                :rules="[rules.required, rules.id]"
                required
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                :rules="[rules.required, rules.password]"
                required
              ></v-text-field>

              <v-checkbox
                v-model="idsave"
                label="Id 저장"
              ></v-checkbox>
              <v-btn class="mt-2" type="submit" block>Login</v-btn>
            </v-form>
          </v-sheet>
        </template>
        </base-material-card>
      </v-col>
    </v-row>
 
  </v-container>
</template>

<script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        id: '',
        password: '',
        idsave: '',
        formValid: false,
        rules: {
          required: v => !!v || '필수 항목입니다.',
          id: v => !v || v.length <= 15 || '15자 이내로 입력하세요.',
          password: v =>
            !!v && /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?-]).{5,}$/.test(v)
            || '영문, 숫자, 특수문자를 포함한 5자 이상이어야 합니다.',
        }

      };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        
          this.loading = true;
          axios.post("/api/login", {
            username: this.id,
            password: this.password
          }).then((response) => {
            const { token, expiresAt, username, roles } = response.data;
 
            const userData = { expiresAt: expiresAt, username: username, roles: JSON.stringify(roles), isLogin: true };
            this.$store.commit('SET_USER', userData); // Vuex에 저장
            sessionStorage.setItem('user', JSON.stringify(userData)); // 로컬에도 저장
            sessionStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
         
            this.$toast.success('성공적으로 로그인되었습니다!');
            this.dialog = false;
            
            // 페이지 이동 (Dashboard)
            this.$router.push('/');
           
          })
          .catch((error) => {
            console.log('error: ', error);
            // const errorMessage = error.response.data?.message || 'Unknown error';
            // alert("로그인 중 오류 발생: " + errorMessage);
          })
          .finally(() => {
            this.loading = false;
          });
       
      }
    },
   
  }
}
</script>
